// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-viewer-container {
  position: relative;
  height: 100%;
}
.entity-viewer-container .entity-viewer-header {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
}
.entity-viewer-container .entity-viewer-header .task-header {
  display: flex;
  align-items: center;
  width: 70%;
}
.entity-viewer-container .entity-viewer-header .task-header-icon {
  border-radius: 50%;
  background: #E9EBEC;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
}
.entity-viewer-container .entity-viewer-header .task-header-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
  max-width: 100%;
  margin: 0px 10px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-name {
  font-size: 15px;
  color: #121414;
  line-height: 32px;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details div {
  display: flex;
  align-items: center;
  gap: 5px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details div .sub-label {
  margin: 0;
  font-size: 12px;
  color: #121414;
  font-weight: 500;
  letter-spacing: 0.2px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details div .sub-value {
  margin: 0;
  font-size: 12px;
  color: #929C9F;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details div .user-img {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  cursor: pointer;
  background-size: contain !important;
}
.entity-viewer-container .entity-viewer-header .task-header-info .task-header-details div .task-status {
  padding: 5px;
  border-radius: 10px;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container {
  display: flex;
  align-items: center;
  width: 25%;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .entity-action-icon {
  flex: 1;
  display: flex;
  justify-content: center;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .entity-action-icon i {
  height: 35px;
  width: 35px;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50%;
  cursor: pointer;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .entity-action-icon i:hover {
  background-color: #f0f0f0;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .actions-dropdown {
  flex: 2;
  display: flex;
  align-items: center;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .actions-dropdown .k-input-inner {
  border-radius: 2px;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .actions-dropdown .k-input-button {
  border-radius: 2px !important;
  background-color: #E9EBEC !important;
}
.entity-viewer-container .entity-viewer-header .entity-actions-container .actions-dropdown .k-picker-solid {
  color: #212121;
  background-color: #ffffff;
  height: 32px;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.1px;
  width: 100%;
}
.entity-viewer-container .entity-viewer-content {
  margin: 30px 0px;
}
@media (max-width: 800px) {
  .entity-viewer-container .entity-viewer-header {
    display: block !important;
  }
  .entity-viewer-container .entity-actions-container {
    margin: 20px 0px !important;
    width: 40% !important;
  }
}
@media (min-width: 800px) {
  .entity-viewer-container .task-header-name {
    font-size: 16px !important;
  }
  .entity-viewer-container .task-header-icon {
    font-size: 20px !important;
    width: 60px !important;
    height: 60px !important;
  }
}
@media (min-width: 1200px) {
  .entity-viewer-container .task-header-name {
    font-size: 18px !important;
  }
  .entity-viewer-container .k-picker-solid {
    font-size: 13px !important;
  }
}
@media (min-width: 1600px) {
  .entity-viewer-container .task-header-name {
    font-size: 20px !important;
  }
  .entity-viewer-container .sub-label,
  .entity-viewer-container .sub-value {
    font-size: 13px !important;
  }
  .entity-viewer-container .k-picker-solid {
    font-size: 14px !important;
  }
}
@media (min-width: 2000px) {
  .entity-viewer-container .entity-viewer-header {
    font-size: 16px;
  }
  .entity-viewer-container .entity-viewer-header .task-header-icon {
    width: 60px;
    height: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/App/EntityViewer/entityViewer.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;AACJ;AACI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AACR;AAEQ;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAAV;AAGQ;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AADV;AAGU;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AADZ;AAIU;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAFZ;AAIY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFd;AAIc;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAFhB;AAKc;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAHhB;AAMc;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AAJhB;AAOc;EACE,YAAA;EACA,mBAAA;AALhB;AAYM;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAVR;AAYQ;EACE,OAAA;EACA,aAAA;EACA,uBAAA;AAVV;AAYU;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAVZ;AAYY;EACE,yBAAA;AAVd;AAeQ;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AAbV;AAeU;EACE,kBAAA;AAbZ;AAgBU;EACE,6BAAA;EACA,oCAAA;AAdZ;AAiBU;EACE,cAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAfZ;AAqBI;EACE,gBAAA;AAnBN;AAsBI;EACE;IACE,yBAAA;EApBN;EAuBI;IACE,2BAAA;IACA,qBAAA;EArBN;AACF;AAwBI;EACE;IACE,0BAAA;EAtBN;EAyBI;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;EAvBN;AACF;AA0BI;EACE;IACE,0BAAA;EAxBN;EA2BI;IACE,0BAAA;EAzBN;AACF;AA4BI;EACE;IACE,0BAAA;EA1BN;EA6BI;;IAEE,0BAAA;EA3BN;EA8BI;IACE,0BAAA;EA5BN;AACF;AAgCI;EACE;IACE,eAAA;EA9BN;EAgCM;IACE,WAAA;IACA,YAAA;EA9BR;AACF","sourcesContent":[".entity-viewer-container {\n    position: relative;\n    height: 100%;\n  \n    .entity-viewer-header {\n      width: 100%;\n      position: relative;\n      z-index: 2;\n      display: flex;\n  \n      .task-header {\n        display: flex;\n        align-items: center;\n        width: 70%;\n        // flex-wrap: wrap;\n  \n        &-icon {\n          border-radius: 50%;\n          background: #E9EBEC;\n          font-size: 18px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex-shrink: 0;\n          width: 50px;\n          height: 50px;\n        }\n  \n        &-info {\n          display: flex;\n          flex-direction: column;\n          flex: 1;\n          gap: 5px;\n          max-width: 100%;\n          margin: 0px 10px;\n  \n          .task-header-name {\n            font-size: 15px;\n            color: #121414;\n            line-height: 32px;\n            font-weight: 500;\n            letter-spacing: 0.3px;\n          }\n  \n          .task-header-details {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 10px;\n  \n            div {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n  \n              .sub-label {\n                margin: 0;\n                font-size: 12px;\n                color: #121414;\n                font-weight: 500;\n                letter-spacing: 0.2px;\n              }\n  \n              .sub-value {\n                margin: 0;\n                font-size: 12px;\n                color: #929C9F;\n                font-weight: 600;\n                letter-spacing: 0.2px;\n              }\n  \n              .user-img {\n                height: 20px;\n                width: 20px;\n                border-radius: 50%;\n                cursor: pointer;\n                background-size: contain!important;\n              }\n  \n              .task-status {\n                padding: 5px;\n                border-radius: 10px;\n              }\n            }\n          }\n        }\n      }\n  \n      .entity-actions-container {\n        display: flex;\n        align-items: center;\n        width: 25%;\n  \n        .entity-action-icon {\n          flex: 1;\n          display: flex;\n          justify-content: center;\n  \n          i {\n            height: 35px;\n            width: 35px;\n            font-size: 18px;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            border-radius: 50%;\n            cursor: pointer;\n  \n            &:hover {\n              background-color: #f0f0f0;\n            }\n          }\n        }\n  \n        .actions-dropdown {\n          flex: 2;\n          display: flex;\n          align-items: center;\n  \n          .k-input-inner {\n            border-radius: 2px;\n          }\n  \n          .k-input-button {\n            border-radius: 2px !important;\n            background-color: #E9EBEC !important;\n          }\n  \n          .k-picker-solid {\n            color: #212121;\n            background-color: #ffffff;\n            height: 32px;\n            font-weight: 500;\n            font-size: 12px;\n            letter-spacing: 0.1px;\n            width: 100%;\n          }\n        }\n      }\n    }\n  \n    .entity-viewer-content {\n      margin: 30px 0px;\n    }\n  \n    @media (max-width: 800px) {\n      .entity-viewer-header {\n        display: block !important;\n      }\n  \n      .entity-actions-container {\n        margin: 20px 0px !important;\n        width: 40% !important;\n      }\n    }\n  \n    @media (min-width: 800px) {\n      .task-header-name {\n        font-size: 16px !important;\n      }\n  \n      .task-header-icon {\n        font-size: 20px !important;\n        width: 60px !important;\n        height: 60px !important;\n      }\n    }\n  \n    @media (min-width: 1200px) {\n      .task-header-name {\n        font-size: 18px !important;\n      }\n  \n      .k-picker-solid {\n        font-size: 13px !important;\n      }\n    }\n  \n    @media (min-width: 1600px) {\n      .task-header-name {\n        font-size: 20px !important;\n      }\n  \n      .sub-label,\n      .sub-value {\n        font-size: 13px !important;\n      }\n  \n      .k-picker-solid {\n        font-size: 14px !important;\n      }\n    }\n  \n    // Larger screens (2000px & above)\n    @media (min-width: 2000px) {\n      .entity-viewer-header {\n        font-size: 16px;\n  \n        .task-header-icon {\n          width: 60px;\n          height: 60px;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
